define.alias("shared/components/shared/carousel/indicators", "calendar/components/shared/carousel/indicators");